import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Grid,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import Image from "src/components/image";

import Iconify from "src/components/iconify";
import { t } from "i18next";

type AccordionProps = {
  profile: {
    title: string;
    subtitle: string;
    usageprice: string;
    maindescription: string;
    subdescription: string;
    imageUrl: string;
  };
  index: number;
  checkboxStates: { checked: boolean; disabled: boolean }[];
  handleCheckboxChange: (index: number) => void;
};

const ProfilesAccordion = ({
  profile,
  index,
  checkboxStates,
  handleCheckboxChange,
}: AccordionProps) => {
  const {
    title,
    subtitle,
    usageprice,
    maindescription,
    subdescription,
    imageUrl,
  } = profile;

  const profileIconWidthMd = "80px";
  const profileIconWidthXs = "40px";

  return (
    <Accordion
      key={index}
      sx={{
        border: "1px solid #ccc",
        borderRadius: "10px",
        mb: 2,

        p: 1,
        "&:before": { display: "none" }, // Remove default Accordion line
        background: checkboxStates[index].checked ? "#007b1442" : "#b4b4b44f",
      }}
    >
      <Grid
        key={index}
        container
        spacing={1}
        alignItems="center"
        sx={{ flexDirection: { xs: "column", md: "row" } }}
      >
        <Grid
          item
          xs={12}
          md={2}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Image
            src={imageUrl}
            ratio="1/1"
            disabledEffect
            sx={{
              borderRadius: 1,
              width: { xs: 60, md: profileIconWidthMd },
              height: { xs: 60, md: "auto" },
            }}
          />
        </Grid>

        <Grid
          item
          xs={12}
          md={6}
          sx={{
            textAlign: { xs: "center", md: "left" },
            mt: { xs: 2, md: 0 },
          }}
        >
          <Typography variant="h6" sx={{ fontWeight: "bold", mb: 0.5 }}>
            {t(title)}
          </Typography>
          {/* <Typography variant="body2" sx={{ mb: 1 }}>
            {t(subtitle)}
          </Typography> */}
        </Grid>

        <Grid
          item
          xs={12}
          md={3}
          sx={{
            display: "flex",
            justifyContent: { xs: "center", md: "flex-end" },
            mt: { xs: 2, md: 0 },
          }}
        >
          <FormControlLabel
            label={
              checkboxStates[index].checked ? t("selected") : t("not_selected")
            }
            control={
              <Checkbox
                size="medium"
                checked={checkboxStates[index].checked}
                disabled={checkboxStates[index].disabled}
                onChange={() => handleCheckboxChange(index)}
              />
            }
            sx={{
              mx: { xs: 0, md: 2 },
              border: "1px solid #ccc",
              borderRadius: 1,
              color: "black",
              padding: 1,
              background: checkboxStates[index].checked
                ? "#007b1442"
                : "#b4b4b44f",
            }}
          />
        </Grid>
        <Grid container spacing={1} alignItems="center">
          <Grid item>
            <Typography variant="body2" sx={{ fontWeight: "medium", ml: 2 }}>
              {t("details")}
            </Typography>
          </Grid>
          <Grid item>
            <AccordionSummary
              expandIcon={<Iconify icon="ph:caret-down-bold" />}
              aria-controls="panel1-content"
              id="panel1-header"
            />
          </Grid>
        </Grid>
      </Grid>

      <AccordionDetails
        sx={{
          backgroundColor: "background.paper",
          borderTop: "1px solid #ddd",
          mt: 2,
          p: 2,
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12} md={4}>
            <Typography variant="body2">{t(subtitle)}</Typography>
          </Grid>
          <Grid item xs={12} md={4}>
            <Typography variant="body2">{t(maindescription)}</Typography>
          </Grid>
          <Grid item xs={12} md={4}>
            <Typography variant="body2">{t(subdescription)}</Typography>
          </Grid>
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
};

export default ProfilesAccordion;
